export default __webpack_public_path__ + "static/media/vessels_closed_sales.bf957ecb.svg";